export default __webpack_public_path__ + "static/media/consensus-reached.325614a3.svg";